import { inject, Injectable } from '@angular/core';
import { FeatureSettings } from '@backModels/FeatureSettings';
import { ConfigApi } from '@shared/api/config.api';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  configApi = inject(ConfigApi);

  private features = {} as FeatureSettings;

  async load(): Promise<void> {
    this.features = await this.configApi.getFeatures();
  }

  isEnabled(flag: string): boolean {
    return this.features[flag as keyof FeatureSettings] === true;
  }
}
